import { css } from '@emotion/react';
import { Col, colors, Row, Title } from 'common-components';
import { Space } from 'antd';
import { useAppTranslation } from '@hooks';

const Header = () => {
  const { translate } = useAppTranslation();
  const texts = [
    {
      type: 'tablePageTitle',
      content: translate('navigation.certifications'),
    },
    {
      type: 'tablePageSubtitle',
      content: translate('certifications.subtitle'),
    },
  ];

  return (
    // @ts-ignore
    <div>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 16px 0;
        `}
      >
        <Col>
          <Row justify={'center'} gutter={30} align={'middle'}>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space key={`title-${text.content}-${index}`} align={'center'}>
                      <Title style={{ fontSize: 18, lineHeight: '28px', color: colors.black }}>
                        {text.content}
                      </Title>
                    </Space>
                  );
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                );
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
